"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetScimLogSearchServiceResponse () {
        return GetScimLogSearchServiceResponse;
    },
    get ScimLogSearchService () {
        return ScimLogSearchService;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../base");
const ScimLogSearchService = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    scimLogType: _models.ScimResourceLogActionType,
    status: _models.ScimResourceLogStatus,
    timestamp: _utilsisomorphic.transformDate,
    affectedUser: _zod.z.object({
        email: _zod.z.string()
    }),
    updates: _zod.z.array(_zod.z.object({
        field_id: _zod.z.instanceof(_bson.ObjectId),
        value: _zod.z.string().or(_zod.z.instanceof(Date)).or(_zod.z.instanceof(_bson.ObjectId)),
        name: _zod.z.string()
    })),
    errorMessage: _zod.z.string().or(_zod.z.null())
});
const GetScimLogSearchServiceResponse = _base.GetBaseSearchServiceResponse.extend({
    results: _zod.z.array(ScimLogSearchService)
});
